import { Pipe, PipeTransform } from '@angular/core';

import { commonUtilitiesCoreService } from '../services/core.service';

@Pipe({
	name: 'commonNAToBlankFormatter',
})
export class CommonNAToBlankFormatter implements PipeTransform {
	transform (data: any): string {
		return !commonUtilitiesCoreService.hasValue(data) ? '' : data;
	}
}
